import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";

const PaginationContext = React.createContext({
  totalPages: 0,
  setTotalPages: () => null,
});
export default PaginationContext;

export const PaginationContextProvider = (props) => {
  const { children = null } = props;

  const [totalPages, setTotalPages] = useState(0);

  const paginationContextValue = useMemo(() => ({ totalPages, setTotalPages }), [totalPages, setTotalPages]);

  return <PaginationContext.Provider value={paginationContextValue}>{children}</PaginationContext.Provider>;
};

PaginationContextProvider.propTypes = {
  children: PropTypes.node,
};
